import { css } from '@emotion/core';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var feature = {
  name: "1r9kwv0",
  styles: "display:flex;flex-direction:row;gap:4px;align-items:center;"
};
export var number = /*#__PURE__*/css(designTokenFonts.miniBold, ";");